<template >
  <div class="mainbody">
    <div style="padding: 16px 32px 16px 0px">
      <span class="title">订单管理</span>
    </div>
    <div class="aLine"></div>
    <div class="tableInfo">
      <el-table :data="data_list" @filter-change="filterChange">
        <el-table-column prop="id" label="订单ID" min-width="2"></el-table-column>
        <el-table-column prop="name_cn" label="用户姓名" min-width="3"></el-table-column>
        <el-table-column prop="create_time" label="创建时间" min-width="2"></el-table-column>
        <el-table-column prop="orderStatus" label="状态" min-width="1" :filters="optionsState" filter-placement="bottom-end" column-key="filterResult"></el-table-column>
        <el-table-column prop="operating" label="操作" min-width="1" align="left">
          <template slot-scope="scope">
            <el-button class="operateText" size="mini" type="text" @click="toDetails(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :key="elementui_page_key"
        class="elPagination"
        background
        layout="prev, pager, next"
        :page-size="pageMaxSize"
        :page-count="pageCount"
        :current-page="currentPage"
        @current-change="currentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import * as Utils from '@/utils/utils.js'
import * as StrUtils from '@/utils/strUtils.js'
import * as Constant from '@/utils/constant.js'
import * as CApi from '@/api/constant_api.js'
import * as Api from '@/api/api.js'
import { URL_PATH, LIST_PAGE_MAX_SIZE } from '@/config/config'
import leftMeun from '@/components/layout/leftMeun'
import headRight from '@/components/layout/headRight'
import headerLayout from '@/components/layout/headerLayoutWxapp'

export default {
  components: {
    leftMeun,
    headRight,
    headerLayout
  },
  data() {
    return {
      urlPath: URL_PATH,
      data_list: [], //数据列表
      optionsState: Constant.options_state_integral_order,
      elementui_page_key: 0,
      pageCount: 0, // 所有页数
      pageMaxSize: LIST_PAGE_MAX_SIZE,
      currentPage: 1,
      filter_result: ''
    }
  },
  activated() {
    this.getList()
  },
  deactivated() {},
  created() {
    this.getList()
  },
  methods: {
    getList: function () {
      this.$api
        .integralOrderList({
          token: localStorage.getItem('token'),
          page: this.currentPage,
          limit: this.pageMaxSize,
          where_order_status: this.filter_result
        })
        .then(({ data }) => {
          let current_page = Utils.listPage(data, this.currentPage)
          if (current_page) {
            this.currentPage = current_page
            this.getList()
          }
          this.pageCount = data.Data.pageCount
          this.data_list = data.Data.model
          this.data_list.forEach(info => {
            this.optionsState.forEach(examin => {
              if (info.order_status == examin.value) {
                info.orderStatus = examin.text
              }
            })
            info.create_time = Utils.dateFormat(info.create_time * 1000)
          })
        })
        .catch(({ error }) => {})
    },
    currentChange(val) {
      this.elementui_page_key++
      this.currentPage = val
      this.getList()
    },
    // 过滤
    filterChange(filters) {
      this.filter_result = StrUtils.getStr4List1(filters.filterResult)
      this.getList()
    },
    // 详情
    toDetails(row) {
      this.$router.push({
        path: '/wxapp/integral_order_details',
        query: {
          id: row.id
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.mainbody {
  overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
  padding-bottom: 58px;
}
.mainbody .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
  padding: 16px 32px;
}
.mainbody .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.mainbody .tableInfo {
  box-sizing: border-box;
  margin-left: 32px;
  margin-right: 32px;
}
.operateText {
  font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/components/integral/orderList.vue